/**
 * Converts an emoji (e.g. '❤️‍🔥') to its unified code representation (e.g. '2764-FE0F-200D-1F525')
 * used by our emoji picker.
 */
export const convertEmojiStringToUnifiedCode = (emojiString: string): string => {
    if (!emojiString) return '';
    return [...emojiString].map((c) => c.codePointAt(0)?.toString(16).toUpperCase()).join('-');
};

/**
 * Converts a unified code representation (e.g. '2764-FE0F-200D-1F525') to its emoji string representation (e.g. '❤️‍🔥').
 */
export const convertUnifiedCodeToEmojiString = (unifiedCode: string): string => {
    if (!unifiedCode) return '';
    return unifiedCode
        .split('-')
        .map((hexStr) => String.fromCodePoint(parseInt(hexStr, 16)))
        .join('');
};
